import {
  Pagination,
  Table,
  ScrollArea,
  Badge,
  Stack,
  Text,
  ThemeIcon,
  ActionIcon,
  LoadingOverlay,
} from "@mantine/core";
import { useNavigate } from "react-router-dom"; // or use window.open
import { useGate, useUnit } from "effector-react";
import { articlesEntityModel } from "../../model/list";
import { ArticleStatus } from "../../types";
import { IconListDetails, IconTrash } from "@tabler/icons-react";

const colorByStatus = {
  [ArticleStatus.completed]: "green",
  [ArticleStatus.pending]: "blue",
  [ArticleStatus.failed]: "red",
};
export const ArticlesList = ({ campaignId }: { campaignId: number }) => {
  const navigate = useNavigate();

  const [list, totalPages, isLoading] = useUnit([
    articlesEntityModel.$list,
    articlesEntityModel.$totalPages,
    articlesEntityModel.$isLoading,
  ]);

  const [page, setPage] = useUnit([
    articlesEntityModel.$page,
    articlesEntityModel.setPage,
  ]);

  const [deleteArticleById] = useUnit([articlesEntityModel.deleteArticleById]);

  useGate(articlesEntityModel.Gate, { campaignId });

  return (
    <ScrollArea>
      <Table highlightOnHover stickyHeader>
        <Table.Thead>
          <Table.Tr>
            <Table.Th p="md">URL</Table.Th>
            <Table.Th p="md">Title</Table.Th>
            <Table.Th p="md">Article Date</Table.Th>
            <Table.Th p="md">Task created Date</Table.Th>
            <Table.Th p="md">Status</Table.Th>
            <Table.Th p="md">Actions</Table.Th>
          </Table.Tr>
        </Table.Thead>

        <Table.Tbody>
          {!isLoading &&
            list.map((item) => (
              <Table.Tr
                key={item.id}
                onClick={() => navigate(`/article-details/${item.id}`)}
                style={{ cursor: "pointer" }}
              >
                <Table.Td style={{ wordBreak: "break-all" }} p="md">{item.originalUrl}</Table.Td>
                <Table.Td p="md">{item.title}</Table.Td>
                <Table.Td p="md">{item.date}</Table.Td>
                <Table.Td p="md">{item.createdAt}</Table.Td>
                <Table.Td p="md">
                  <Badge color={colorByStatus[item.status]} variant="light">
                    {item.status === ArticleStatus.completed && "Finished"}
                    {item.status === ArticleStatus.pending && "Processing"}
                    {item.status === ArticleStatus.failed && "Failed"}
                  </Badge>
                </Table.Td>
                <Table.Td p="md">
                  <ActionIcon
                    w={"100%"}
                    variant="subtle"
                    title="Удалить статью"
                    onClick={(e) => {
                      e.stopPropagation();
                      deleteArticleById(item.id);
                    }}
                  >
                    <IconTrash />
                  </ActionIcon>
                </Table.Td>
              </Table.Tr>
            ))}
          {!isLoading && list.length === 0 && (
            <Table.Tr w={"100%"}>
              <Table.Td colSpan={6} p="md" bg="white" w={"100%"}>
                <Stack align="center" justify="center" h="200px">
                  <ThemeIcon size={52} radius="sm" variant="light" color="blue">
                    <IconListDetails />
                  </ThemeIcon>
                  <Text size="sm" fw={500}>
                    No articles found yet
                  </Text>
                  <Text size="sm" c="dimmed">
                    The articles will be displayed here after the adding tasks
                    to the campaign.
                  </Text>
                </Stack>
              </Table.Td>
            </Table.Tr>
          )}

          {isLoading && (
            <Stack flex={1} mih={200}>
              <Stack
                mih={200}
                pos={"absolute"}
                top={0}
                left={0}
                right={0}
                bottom={0}
              >
                <LoadingOverlay
                  visible={isLoading}
                  zIndex={100}
                  overlayProps={{
                    radius: "sm",
                    blur: 5,
                    backgroundOpacity: 0.8,
                  }}
                  loaderProps={{ type: "bars" }}
                />
              </Stack>
            </Stack>
          )}
        </Table.Tbody>

        <Table.Tfoot>
          <Table.Tr>
            <Table.Td colSpan={3}>
              <Pagination
                total={totalPages}
                siblings={1}
                value={page}
                onChange={setPage}
              />
            </Table.Td>
          </Table.Tr>
        </Table.Tfoot>
      </Table>
    </ScrollArea>
  );
};
